import React from 'react';

const NeedPage = () => <div>need page</div>;

export default NeedPage;
